import React, { Component } from "react";
import { withRouter } from "react-router";
import { get } from "lodash";
import moment from "moment";
import {
  getDayOfTheGivenDate,
  dateFormat,
  getTimeOfTheGivenDate
} from "../../helper";
import { PATHS } from "../../constant";

class AgendaDecision extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  changePathToAgenda = e => {
    const { history } = this.props;
    /*history.push(PATHS.AGENDA_DETAILS, {
      agendaId: e.target.innerHTML && e.target.innerHTML.replace("#", "")
    });*/

    history.push({
      pathname: PATHS.AGENDA_DETAILS,
      search: `?agendaId=${e.target.innerHTML &&
        e.target.innerHTML.replace("#", "")}`,
      state: {
        agendaId: e.target.innerHTML && e.target.innerHTML.replace("#", "")
      }
    });
  };

  render() {
    let { agendaDetail: details, listStatus, redirectToAgenda } = this.props;
    const agendaDetail = { ...details };
    agendaDetail.id =
      get(agendaDetail, "meetingDTO.id", null) ||
      agendaDetail.meetingId ||
      (get(agendaDetail, "meetingDate") && agendaDetail.id);
    if (!listStatus) {
      agendaDetail.venueName = get(agendaDetail, "meetingDTO.venue", null);
      agendaDetail.meetingType = get(
        agendaDetail,
        "meetingDTO.meetingType",
        null
      );
      agendaDetail.meetingChairedBy = get(
        agendaDetail,
        "meetingDTO.meetingChairedBy",
        null
      );
      agendaDetail.meetingDate = get(
        agendaDetail,
        "meetingDTO.time",
        new Date()
      );
    }
    const date =
      (get(agendaDetail, "meetingDate") &&
        new Date(get(agendaDetail, "meetingDate"))) ||
      null;

    return (
      <div className="add-decision-headers agenda-decision col-md-4">
        {get(agendaDetail, "id") ? (
          <div className="agenda-detail-header">
            {window.location.pathname != "/agenda-details" ? (
              <>
                <div className="agenda-detail-info add-decision-title decision-info">
                  <div className="agenda-list-title decision-id">
                    Agenda{" "}
                    <span
                      className="agenda-decision-id"
                      onClick={
                        redirectToAgenda
                          ? redirectToAgenda
                          : this.changePathToAgenda
                      }
                    >
                      #{get(agendaDetail, "id", "NA")}
                    </span>
                  </div>
                </div>
                <h3 className="decision-subgroup-meeting">Subgroup Meeting</h3>
              </>
            ) : (
              ""
            )}

            <div className="agenda-detail-info decision-info meeting-info decision-agenda-detail">
              <span>
                <b>When</b>
                {get(agendaDetail, "meetingDTO") ? (
                  <>
                    {getDayOfTheGivenDate(
                      get(agendaDetail, "meetingDTO.meetingDate", null)
                    ) +
                      ", " +
                      dateFormat(get(agendaDetail, "meetingDTO.meetingDate"))}
                    {", "}
                    {getTimeOfTheGivenDate(
                      get(agendaDetail, "meetingDTO.time", null)
                    )}
                  </>
                ) : (
                  <>
                    {getDayOfTheGivenDate(
                      get(agendaDetail, "meetingDate", null)
                    ) +
                      ", " +
                      dateFormat(get(agendaDetail, "meetingDate"))}
                    {", "}
                    {getTimeOfTheGivenDate(
                      get(agendaDetail, "meetingTimeFrom", null)
                    )}
                  </>
                )}
              </span>
            </div>
            <div className="agenda-detail-info decision-info meeting-venue decision-agenda-detail">
              <span>
                <b>Venue</b>
                {get(agendaDetail, "venueName")}
              </span>
            </div>
            {window.location.pathname == "/agenda-details" ? (
              <>
                <div className="agenda-detail-info decision-info meeting-type meet-type-agenda decision-agenda-detail">
                  <span>
                    <b>Meeting type</b>
                    {get(agendaDetail, "meetingType")}
                  </span>
                </div>
                <div className="agenda-detail-info decision-info meeting-chaired-by decision-agenda-detail">
                  <span>
                    <b>Chaired by</b>
                    {get(agendaDetail, "meetingChairedBy")}
                  </span>
                </div>
              </>
            ) : (
              ""
            )}
          </div>
        ) : (
          <div className="agenda-detail-header">
            <h3 className="decision-subgroup-meeting">
              Decision Without Agenda
            </h3>
          </div>
        )}
      </div>
    );
  }
}

export default withRouter(AgendaDecision);
